module.exports = __webpack_public_path__ + "static/media/Cherrim_gaussian2.0f3de0a7.png";